import { useToggle } from "client/hooks/utils/useToggle";
import { setLoaded } from "store/features/memeGenerator/actions";
import { fetchFontsThunk } from "store/features/memeGenerator/extraReducers/fetchFonts";
import { MemeGeneratorState } from "store/features/memeGenerator/types";
import { store, useAppDispatch, useAppSelector } from "store/store";
import { loadFont } from "store/utils/loadFont";
import { useRecentlyUsedFonts } from "./useRecentlyUsedFonts";

export const useFont = () => {
    const { handleRecentlyUsedFontsLoad } = useRecentlyUsedFonts();
    const dispatch = useAppDispatch();
    const { open: _open, isOpen, onClose: close, toggle } = useToggle();
    async function open() {
        _open();
        if (
            store.getState().memeGenerator.googleFonts.isFetching ||
            store.getState().memeGenerator.googleFonts.list.length > 0
        )
            return;
        await dispatch(fetchFontsThunk());
        loadMoreGoogleFonts();
        handleRecentlyUsedFontsLoad();
    }

    const loadedFonts = useAppSelector((store) => store.memeGenerator.googleFonts).list.filter(
        (font) => font.hasLoaded,
    );

    async function loadMoreGoogleFonts() {
        const toBeLoadedFonts = store
            .getState()
            /**
             * Loading extra files for original font disrupts the styles.
             */
            .memeGenerator.googleFonts.list.filter((font) => font.family !== "Source Sans Pro")
            .slice(loadedFonts.length, loadedFonts.length + 10);
        await Promise.all(toBeLoadedFonts.map((font) => loadSingleFont(font)));
        toBeLoadedFonts.forEach((font) => dispatch(setLoaded(font.family)));
    }

    async function loadSingleFont(font: MemeGeneratorState["googleFonts"]["list"][number]) {
        await Promise.all(
            font.variants.filter((v) => v === "regular").map((variant) => loadFont(font.family, font.files[variant])),
        );
    }

    return {
        open,
        isOpen,
        close,
        toggle,
        loadedFonts,
        loadMoreGoogleFonts,
    };
};
